import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=f47ef206&scoped=true&"
import script from "./ThemeSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=f47ef206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47ef206",
  null
  
)

export default component.exports